// src/pages/trading-portal/notifications/NotificationsPage.js
// Thin wrapper that re-uses the creator panel's NotificationsPage rendering
// with `panel_type='trading'` and the trading panel's amber accent baked in.

import React from 'react';
import CreatorNotificationsPage from '../../creator-panel/notifications/NotificationsPage';

const TRADING_ACCENT = '#f59e0b';
const TRADING_ACCENT_HOVER = '#d97706';

export default function TradingNotificationsPage() {
    return (
        <CreatorNotificationsPage
            panelType="trading"
            accent={TRADING_ACCENT}
            accentHover={TRADING_ACCENT_HOVER}
            pageTitle="Notifications | Trading Portal"
        />
    );
}
